import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function AuthButton() {
  const { user } = useAuth();

  if (user) {
    return (
      <Link to="/account" className="btn btn-primary">
        My Account
      </Link>
    );
  }

  return (
    <Link to="/sign-in" className="btn btn-primary">
      Sign In
    </Link>
  );
}